/**
 * XML character escape map.
 * Replaces characters that are invalid in XML text/attribute values.
 */
const XML_ESCAPE_MAP: ReadonlyMap<string, string> = new Map([
  ['&', '&amp;'],
  ['<', '&lt;'],
  ['>', '&gt;'],
  ['"', '&quot;'],
  ["'", '&apos;'],
]);

/**
 * Escape a string for safe inclusion in XML content.
 * Uses a character-by-character map lookup (no regex).
 */
export function escapeXml(value: string): string {
  let result = '';
  for (const char of value) {
    const escaped = XML_ESCAPE_MAP.get(char);
    result += escaped ?? char;
  }
  return result;
}

/** Build an XML attribute string: key="escaped-value" */
export function xmlAttr(key: string, value: string | number): string {
  return `${key}="${escapeXml(String(value))}"`;
}

/** Build a self-closing XML element with attributes */
export function xmlSelfClosing(tag: string, attrs: Record<string, string | number>): string {
  const attrStr = Object.entries(attrs)
    .map(([k, v]) => xmlAttr(k, v))
    .join(' ');
  return `<${tag} ${attrStr} />`;
}

/** Build an XML element wrapping text content */
export function xmlElement(tag: string, content: string): string {
  return `<${tag}>${escapeXml(content)}</${tag}>`;
}
